module.exports = __webpack_public_path__ + "static/media/204_SHOT_357A.ffc022cc.webp";